<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-demo__news">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-form-item>
                    <el-cascader style="width:445px" v-model="dataForm.cunName" :options="AreaTree" placeholder="请选择村委"
                                 :props="{ expandTrigger: 'hover', label: 'name', value: 'name' }" filterable clearable></el-cascader>
                </el-form-item>
                <el-form-item>
                    <el-select @change="changeSex" v-model="dataForm.sex" placeholder="请选择性别">
                        <el-option v-for="item in sexOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="dataForm.ageSection" placeholder="请选择年龄段">
                        <el-option v-for="item in AgeGroup" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <br>
                <el-form-item>
                    <el-select v-model="dataForm.working" placeholder="是否已就业">
                        <el-option v-for="item in workOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="dataForm.hasWorkIntent" placeholder="是否有就业意向">
                        <el-option v-for="item in workOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="dataForm.requireTraining" placeholder="是否需要残联培训">
                        <el-option v-for="item in workOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="dataForm.name" placeholder="请输入姓名或手机号" clearable></el-input>
                </el-form-item>
                <br>


                <el-form-item>
                    <el-button @click="getDataList()">查询</el-button>
                    <el-button @click="exportHandle()" type="primary">导出数据</el-button>
                </el-form-item>
            </el-form>
            <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle"
                      @sort-change="dataListSortChangeHandle" style="width: 100%">
                <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                <el-table-column prop="id" label="ID" header-align="center" align="center"></el-table-column>
                <el-table-column prop="xm" label="姓名" header-align="center" align="center"></el-table-column>
                <el-table-column prop="mobile" label="联系电话" header-align="center" align="center"></el-table-column>
                <el-table-column prop="cjPosition" label="残疾等级" header-align="center" align="center"></el-table-column>
                <el-table-column prop="working" label="是否已就业" header-align="center" align="center"></el-table-column>
                <el-table-column prop="hasWorkIntent" label="是否有求职意向" header-align="center" align="center"></el-table-column>
                <el-table-column prop="updateDate" label="上次调查时间" header-align="center" align="center"></el-table-column>
                <el-table-column label="操作" fixed="right" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="lookDetail(scope.row)">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="limit" :total="total"
                           layout="total, sizes, prev, pager, next, jumper" @size-change="pageSizeChangeHandle"
                           @current-change="pageCurrentChangeHandle">
            </el-pagination>
            <!-- 查看详情-->
            <condition-detail v-if="OpenViewAssociation" ref="ViewAssociation"></condition-detail>
        </div>
    </el-card>
</template>

<script>
    import mixinViewModule from "@/mixins/view-module";
    import conditionDetail from './conditionDetail';
    export default {
        mixins: [mixinViewModule],
        components: {
            conditionDetail
        },
        data() {
            return {
                mixinViewModuleOptions: {
                    getDataListURL: "/extension/page",
                    getDataListIsPage: true,
                    createdIsNeed: true,
                    exportURL: "/extension/export"
                },
                daterange: null,
                dataForm: {
                    name: "",
                    ageSection: "",
                    cunName: "",
                    sex: "",
                    working: "",
                    hasWorkIntent: "",
                    requireTraining: "",
                    area: JSON.parse(localStorage.getItem('org')).area || ''
                },
                OpenViewAssociation: false,
                sexOptions: [
                    {
                        value: '男',
                        label: '男'
                    },
                    {
                        value: '女',
                        label: '女'
                    },
                ],
                workOptions: [
                    {
                        value: '是',
                        label: '是'
                    },
                    {
                        value: '否',
                        label: '否'
                    },
                ],

                AgeGroup: [],
                AreaTree: [],

            };
        },
        watch: {
            daterange(val) {
                if (val == null) {
                    this.dataForm.startDate = null;
                    this.dataForm.endDate = null;
                } else {
                    this.dataForm.startDate = val[0];
                    this.dataForm.endDate = val[1];
                }
            },
        },
        created() {
            this.getAreaTree();
        },
        methods: {
            getAreaTree() {
                //获取地区数据
                axios
                    .get(this.$baseURL + "/api/area/tree", {
                        params: {
                            token:
                                "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI1IiwiaWF0IjoxNjc4MTc3MTQ5LCJleHAiOjE2NzgxODA3NDl9.FcGvp4OjE5B0ZDswvc8hrsGr4Ykqzzp8eLbFXT7m_SJVjBRBIq3Ab8HXqN6dfoMQDpXk-dsMcDZb-TRt0mb7yw",
                            area: JSON.parse(localStorage.getItem('org')).area || ''
                        },
                    })
                    .then(({ data: res }) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg);
                        }
                        this.AreaTree = res.data;
                    })
                    .catch(() => { });
            },
            getAgeGroup(type) {
                //获取年龄段
                axios
                    .get(this.$baseURL + "/api/sys/dict", {
                        params: {
                            type: type,
                        },
                    })
                    .then(({ data: res }) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg);
                        }
                        this.AgeGroup = res.data;
                    })
                    .catch(() => { });
            },
            changeSex(e) {
                this.dataForm.ageSection = ''
                let type = null
                if (e == '男') {
                    type = 'men_Age'
                } else {
                    type = 'women_Age'
                }
                this.getAgeGroup(type)
            },
            lookDetail(row) {
                //查看详情
                this.OpenViewAssociation = true;
                this.$nextTick(() => {
                    this.$refs.ViewAssociation.init(row);
                });
            },
        },
    };
</script>
